const RETURN_REQUEST_ENQUIRY = 'I want to enquire about my return request.';
const DELIVERY_DATE_ENQUIRY = 'I want to enquire about the estimated date of delivery of my shipment.';
const FUTURE_DATE_DELIVERY = 'I want future date delivery.';
const RESCHEDULE_SHIPMENT = 'I want to reschedule my shipment.';
// Pending-for-Pickup reschedule button (no "my shipment", no period). Shown
// under the "I have pickup related concern" hub. Distinct from
// RESCHEDULE_SHIPMENT above — the pending-for-pickup flow is Reverse+Pending
// and always eligible, so OptionsHandler.getTicketDetails skips the shipment-
// status gating used for the forward RESCHEDULE_SHIPMENT branch.
const RESCHEDULE_PICKUP = 'I want to reschedule my pickup';
const SELF_COLLECT = 'I want to self collect my order.';
const SELF_COLLECT_SHIPMENT = 'I want to self collect my shipment.';
const FUTURE_PICKUP_DATE = 'I want future pickup date.';
const UPDATE_ALTERNATE_CONTACT = 'I want to update my alternate contact number.';
// Legacy alt-contact entry label from the RTO / forward flows (no "my", no
// trailing period) — kept because seeded flow docs and CRM logs already
// reference this exact string.
const UPDATE_ALT_CONTACT_LEGACY = 'I want to update alternate contact number';
// Pending-for-Pickup contact-details sub-button label (matches the flowchart
// spec: "Update alternate mobile number"). Both this and the two labels above
// resolve to the same handler in ChatBot.jsx (see the || chain around
// line 162 of handleInputSubmit).
const UPDATE_ALT_MOBILE_PICKUP = 'Update alternate mobile number';
const UPDATE_ALTERNATE_CONTACT_BUTTON = 'I want to update alternate contact number';
const UPDATE_CONTACT_ADDRESS = 'I want to change the address';
const CHANGE_ADDRESS_CONFIRMATION = 'Change address confirmation';
const UPDATE_CONTACT_DETAILS_MENU = 'I want to update my contact details.';
const SHIPMENT_NOT_RECEIVED = 'I have not received my shipment yet.';
const MISBEHAVIOR_BY_SR = 'It is about misbehavior by the service representative.';
const CHARGED_EXTRA_AMOUNT = 'I have been charged extra amount by the service representative.';
const WRONG_PRODUCT_PICKED = 'Wrong return product has been picked by service representative.';
const PRODUCT_NOT_PICKED = 'The return product is not yet picked.';
const PRODUCT_DAMAGED = 'The product is damaged';
const PRODUCT_MISSING = 'The product is missing';
const STATUS_ENQUIRY = 'I want to enquire the status.';
const REQUEST_REGISTER = 'I want to register a request.';
const COMPLAINT_REGISTER = 'I want to raise a new complaint.';
const MIS_DAM_PRODUCT = 'The product delivered in damaged/missing.';
const CUSTOMER_CARE_NUMBER = '02049116100';
const CUSTOMER_CARE_CLICKABLE = `<a href="tel:${CUSTOMER_CARE_NUMBER}">${CUSTOMER_CARE_NUMBER}</a>`;
const CUSTOMER_CARE_CONNECT_PROMPT = 'Do You want to connect with the customer care team?';

// Session flow identifiers (current-flow) and MongoDB flow type keys
const NDR_CWFD_AGREEMENT = 'NDR CWFD agreement';
const NDR_CWFD_CALL_LOG = 'NDR CWFD call log';
const NDR_CWFD_REATTEMPT = 'NDR CWFD reattempt';
const NDR_CWFD_REATTEMPT_DELAY = 'NDR CWFD reattempt delay';
const NDR_CWFD_MAX_ATTEMPTS = 'NDR CWFD max attempts';
const NDR_CWFD_FLOW_END = 'NDR CWFD complete';

const NDR_CRA_AGREEMENT = 'NDR CRA agreement';
const NDR_CRA_CALL_LOG = 'NDR CRA call log';
const NDR_CRA_REATTEMPT = 'NDR CRA reattempt';
const NDR_CRA_REATTEMPT_DELAY = 'NDR CRA reattempt delay';
const NDR_CRA_MAX_ATTEMPTS = 'NDR CRA max attempts';
const NDR_CRA_FLOW_END = 'NDR CRA complete';

const NDR_ADI_AGREEMENT = 'NDR ADI agreement';
const NDR_ADI_CALL_LOG = 'NDR ADI call log';
const NDR_ADI_REATTEMPT = 'NDR ADI reattempt';
const NDR_ADI_REATTEMPT_DELAY = 'NDR ADI reattempt delay';
const NDR_ADI_FLOW_END = 'NDR ADI complete';

const NPR_ADI_AGREEMENT = 'NPR ADI agreement';
const NPR_ADI_CALL_LOG = 'NPR ADI call log';
const NPR_ADI_REATTEMPT = 'NPR ADI reattempt';
const NPR_ADI_FLOW_END = 'NPR ADI complete';

const NDR_PNC_MAX_ATTEMPTS = 'NDR PNC max attempts';
const NDR_PNC_REATTEMPT = 'NDR PNC reattempt';
const NDR_PNC_REATTEMPT_DELAY = 'NDR PNC reattempt delay';
const NDR_PNC_RESCHEDULE = 'NDR PNC reschedule';
const NDR_PNC_DATE_SELECTION = 'NDR PNC date selection';
const NDR_PNC_FLOW_END = 'NDR PNC complete';

const RPCANCEL_REFUND_MAX_ATTEMPTS = 'RPCancel refund max attempts';
const RPCANCEL_REFUND_REATTEMPT = 'RPCancel refund reattempt';
const RPCANCEL_REFUND_RESCHEDULE = 'RPCancel refund reschedule';
const RPCANCEL_REFUND_DATE_SELECTION = 'RPCancel refund date selection';
const RPCANCEL_REFUND_FLOW_END = 'RPCancel refund complete';
const RPCANCEL_PICKUP_AGREEMENT = 'RPCancel pickup agreement';
const RPCANCEL_PICKUP_CALL_LOG = 'RPCancel pickup call log';
const RPCANCEL_PICKUP_REATTEMPT = 'RPCancel pickup reattempt';
const RPCANCEL_PICKUP_MAX_ATTEMPTS = 'RPCancel pickup max attempts';
const RPCANCEL_PICKUP_FLOW_END = 'RPCancel pickup complete';

const NPR_RESCHEDULE_PICKUP = 'NPR RESCHEDULE PICKUP';
const NPR_PICKUP_DATE_SELECTION = 'NPR RESCHEDULE PICKUP DATE';

const NPR_HANDED_AGREEMENT = 'NPR handed agreement';
const NPR_HANDED_CALL_LOG = 'NPR handed call log';
const NPR_HANDED_NOT_VALIDATED = 'NPR handed not validated';
const NPR_HANDED_FLOW_END = 'NPR handed complete';
const NPR_CWFP_AGREEMENT = 'NPR CWFP agreement';
const NPR_CWFP_CALL_LOG = 'NPR CWFP call log';
const NPR_CWFP_REATTEMPT = 'NPR CWFP reattempt';
const NPR_CWFP_FLOW_END = 'NPR CWFP complete';
// Backend npr_pickup_not_done_flow uses this exact label for fetch-records routing.
const NPR_PICKUP_WHERE_IS_LABEL = 'Where is my shipment';

const STILL_HAVE_QUERY = 'Do you still have a query?';

const RIDER_CONCERNS_MENU = 'I have rider related concerns';
const RIDER_CONCERN_FLOW = 'rider concern';
const RIDER_INCIDENT_DATE_PROMPT = 'Can you please help us know when did this incident happen?';
const RIDER_CONCERN_DESCRIBE_PLACEHOLDER = 'Please describe the incident.';

const NDR_ENQUIRY_MENU = 'NDR enquiry menu';
const NDR_SHIPMENT_CONCERNS_MENU = 'NDR shipment concerns menu';
const NDR_ENQUIRY_MONGO_TYPE = 'ndr';
const NDR_SHIPMENT_CONCERNS_MONGO_TYPE = 'I have shipment related concerns';
// Mongo renamed the enquiry-menu button label; the flow documents are still
// keyed by the legacy "...concerns" type, so label and type differ.
const SHIPMENT_CONCERNS_BUTTON = 'I have shipment related queries.';
const NPR_ENQUIRY_MENU = 'NPR enquiry menu';
const NPR_SHIPMENT_CONCERNS_MENU = 'NPR shipment concerns menu';
const NPR_ENQUIRY_MONGO_TYPE = 'npr';
const NPR_SHIPMENT_CONCERNS_MONGO_TYPE = 'I have shipment related concern';
const CANCEL_ORDER = 'I want to cancel my shipment.';
const WHERE_IS_MY_SHIPMENT = 'where is my shipment?';
const DELAY_APOLOGY_MESSAGE = 'We sincerely apologize for the delay in your shipment and are actively working to ensure it reaches you at the earliest.';
const ORDER_STATUS_DATE= 'Your shipment has arrived at your nearest hub and will be attempted to you on or before';
const INVALID_AWB_MESSAGE = 'Entered AWB number is incorrect. Kindly enter the correct AWB number or mobile number';
const INVALID_MOBILE_MESSAGE = 'Entered mobile number is incorrect. Kindly enter the correct mobile number or AWB';
const ALT_MOBILE_INCORRECT_MESSAGE = 'Your alternate mobile number is incorrect. Please enter the correct mobile number';
const ALT_MOBILE_OTP_SENT_MESSAGE = 'OTP has been sent to your alternate mobile number';
const ALT_MOBILE_OTP_INCORRECT_MESSAGE = 'Kindly enter the correct OTP to update the alternate mobile number';
const ALT_MOBILE_OTP_PROMPT = 'Please enter the 6-digit OTP sent to your alternate mobile number';
const ALT_MOBILE_OTP_LOCKED_MESSAGE = "The OTP entered is incorrect. We're redirecting you to the main menu, please try again after some time.";
const LOGIN_OTP_LOCKED_MESSAGE = "You've reached the maximum number of incorrect OTP attempts, so we're redirecting you to the main menu.";

const DELIVERED_ENQUIRY_MONGO_TYPE = 'delivered';
const DELIVERED_ENQUIRY_MONGO_TYPE_ALT = 'deliverd';
const DELIVERED_SHIPMENT_CONCERNS_MENU = 'Delivered shipment concerns menu';
const DELIVERED_SHIPMENT_CONCERNS_MONGO_TYPE = 'I have shipment related concerns delivered';
const DELIVERED_NOT_RECEIVED = 'I have not received my shipment';
const DELIVERED_NOT_RECEIVED_AGREEMENT = 'Delivered not received agreement';
const DELIVERED_INCORRECT_SHIPMENT_PREFIX = 'I have received an incorrect shipment';
const DELIVERED_INCORRECT_SHIPMENT_FLOW = 'Delivered incorrect shipment';
const DELIVERED_FLOW_END = 'Delivered flow complete';

// Flip to true after chatBot_Flows_Collection has delivered menus seeded in Mongo.
const DELIVERED_USE_MONGO_MENUS = false;

const DELIVERED_ENQUIRY_MENU_FALLBACK = [
    { type: 'text', content: 'How can we help you?' },
    { type: 'button', content: SHIPMENT_CONCERNS_BUTTON },
    { type: 'button', content: 'I have rider related concerns' },
];

export const constants = {
    RETURN_REQUEST_ENQUIRY,
    DELIVERY_DATE_ENQUIRY,
    FUTURE_DATE_DELIVERY,
    RESCHEDULE_SHIPMENT,
    RESCHEDULE_PICKUP,
    SELF_COLLECT,
    SELF_COLLECT_SHIPMENT,
    FUTURE_PICKUP_DATE,
    UPDATE_ALTERNATE_CONTACT,
    UPDATE_ALTERNATE_CONTACT_BUTTON,
    UPDATE_ALT_CONTACT_LEGACY,
    UPDATE_ALT_MOBILE_PICKUP,
    UPDATE_CONTACT_ADDRESS,
    CHANGE_ADDRESS_CONFIRMATION,
    UPDATE_CONTACT_DETAILS_MENU,
    SHIPMENT_NOT_RECEIVED,
    MISBEHAVIOR_BY_SR,
    CHARGED_EXTRA_AMOUNT,
    WRONG_PRODUCT_PICKED,
    PRODUCT_NOT_PICKED,
    PRODUCT_DAMAGED,
    PRODUCT_MISSING,
    'prompt_of_additional_options' : 'Additional options',
    'prompt_of_complaint_confirmation' : 'Complaint confirmation',
    'status_buttons' : [RETURN_REQUEST_ENQUIRY, DELIVERY_DATE_ENQUIRY],
    'request_buttons' : [FUTURE_DATE_DELIVERY, RESCHEDULE_SHIPMENT, SELF_COLLECT, UPDATE_ALTERNATE_CONTACT, UPDATE_CONTACT_ADDRESS, FUTURE_PICKUP_DATE],
    'complaint_buttons' : [SHIPMENT_NOT_RECEIVED, MISBEHAVIOR_BY_SR, CHARGED_EXTRA_AMOUNT, WRONG_PRODUCT_PICKED, PRODUCT_NOT_PICKED, PRODUCT_DAMAGED, PRODUCT_MISSING],
    'prompt_of_otp' : 'OTP',
    'prompt_of_number' : 'Number Prompt',
    'prompt_of_otp_locked' : 'OTP-LOCKED',
    'prompt_of_fetch_records' : 'fetch-records',
    'prompt_of_fetch_records_otp' : 'fetch-records-otp',
    'prompt_of_invalid_number' : 'Invalid Number',
    'session_keys' : ['awb', 'button-name', 'current-flow', 'intent-name', 'intent-ticket', 'mobileno', 'valid', 'intent-value', 'otpSent', 'otpAttempts', 'registeredNo', 'shipmentType', 'edd', 'attemptCount', 'shipmentStatus', 'businessType', 'clientName', 'deliveryDate', 'pddBreach', 'ndrDate', 'ndrReason', 'reattemptDate', 'WHHandOver', 'addressUpdateStep', 'addressPincode', 'riderName', 'ndrVerificationSource', 'cwfp-reattempt-ticket-created', 'ndrShipmentSnapshot', 'nprShipmentSnapshot', 'deliveredClosingFlow'],
    NDR_ENQUIRY_MENU,
    NDR_SHIPMENT_CONCERNS_MENU,
    NDR_ENQUIRY_MONGO_TYPE,
    NDR_SHIPMENT_CONCERNS_MONGO_TYPE,
    SHIPMENT_CONCERNS_BUTTON,
    NPR_ENQUIRY_MENU,
    NPR_SHIPMENT_CONCERNS_MENU,
    NPR_ENQUIRY_MONGO_TYPE,
    NPR_SHIPMENT_CONCERNS_MONGO_TYPE,
    RIDER_CONCERNS_MENU,
    RIDER_CONCERN_FLOW,
    RIDER_INCIDENT_DATE_PROMPT,
    RIDER_CONCERN_DESCRIBE_PLACEHOLDER,
    MIS_DAM_PRODUCT,
    CANCEL_ORDER,
    WHERE_IS_MY_SHIPMENT,
    DELAY_APOLOGY_MESSAGE,
    ORDER_STATUS_DATE,
    INVALID_AWB_MESSAGE,
    INVALID_MOBILE_MESSAGE,
    ALT_MOBILE_INCORRECT_MESSAGE,
    ALT_MOBILE_OTP_SENT_MESSAGE,
    ALT_MOBILE_OTP_INCORRECT_MESSAGE,
    ALT_MOBILE_OTP_PROMPT,
    ALT_MOBILE_OTP_LOCKED_MESSAGE,
    LOGIN_OTP_LOCKED_MESSAGE,
    'prompt_of_quick_response' : 'Click on the appropriate Quick Response button.',
    'prompt_of_valid_input' : 'Please enter valid input here',
    'prompt_of_welcome' : 'Hello and welcome to Xpressbees.\nPlease enter your AWB number/registered mobile number',
    'OTP_MAX_ATTEMPTS': 3,
    'rvp_flag' : ['complaint-raise-wrong-picked', 'complaint-raise-not-picked'],
    'additionalButtons' : ['Yes please.', 'No, Thanks!'],
    'fwd_buttons' : [SHIPMENT_NOT_RECEIVED, CHARGED_EXTRA_AMOUNT, FUTURE_DATE_DELIVERY, RESCHEDULE_SHIPMENT, SELF_COLLECT, PRODUCT_DAMAGED, PRODUCT_MISSING],
    'rvp_buttons' : [WRONG_PRODUCT_PICKED, PRODUCT_NOT_PICKED, FUTURE_PICKUP_DATE],
    'home_buttons' : [REQUEST_REGISTER, COMPLAINT_REGISTER, STATUS_ENQUIRY],
    NDR_CWFD_AGREEMENT,
    NDR_CWFD_CALL_LOG,
    NDR_CWFD_REATTEMPT,
    NDR_CWFD_REATTEMPT_DELAY,
    NDR_CWFD_MAX_ATTEMPTS,
    NDR_CWFD_FLOW_END,
    NDR_CRA_AGREEMENT,
    NDR_CRA_CALL_LOG,
    NDR_CRA_REATTEMPT,
    NDR_CRA_REATTEMPT_DELAY,
    NDR_CRA_MAX_ATTEMPTS,
    NDR_CRA_FLOW_END,
    NDR_ADI_AGREEMENT,
    NDR_ADI_CALL_LOG,
    NDR_ADI_REATTEMPT,
    NDR_ADI_REATTEMPT_DELAY,
    NDR_ADI_FLOW_END,
    NPR_ADI_AGREEMENT,
    NPR_ADI_CALL_LOG,
    NPR_ADI_REATTEMPT,
    NPR_ADI_FLOW_END,
    NDR_PNC_MAX_ATTEMPTS,
    NDR_PNC_REATTEMPT,
    NDR_PNC_REATTEMPT_DELAY,
    NDR_PNC_RESCHEDULE,
    NDR_PNC_DATE_SELECTION,
    NDR_PNC_FLOW_END,
    RPCANCEL_REFUND_MAX_ATTEMPTS,
    RPCANCEL_REFUND_REATTEMPT,
    RPCANCEL_REFUND_RESCHEDULE,
    RPCANCEL_REFUND_DATE_SELECTION,
    RPCANCEL_REFUND_FLOW_END,
    RPCANCEL_PICKUP_AGREEMENT,
    RPCANCEL_PICKUP_CALL_LOG,
    RPCANCEL_PICKUP_REATTEMPT,
    RPCANCEL_PICKUP_MAX_ATTEMPTS,
    RPCANCEL_PICKUP_FLOW_END,
    NPR_RESCHEDULE_PICKUP,
    NPR_PICKUP_DATE_SELECTION,
    NPR_HANDED_AGREEMENT,
    NPR_HANDED_CALL_LOG,
    NPR_HANDED_NOT_VALIDATED,
    NPR_HANDED_FLOW_END,
    NPR_CWFP_AGREEMENT,
    NPR_CWFP_CALL_LOG,
    NPR_CWFP_REATTEMPT,
    NPR_CWFP_FLOW_END,
    NPR_PICKUP_WHERE_IS_LABEL,
    STILL_HAVE_QUERY,
    NDR_ENQUIRY_MENU,
    NDR_SHIPMENT_CONCERNS_MENU,
    NDR_ENQUIRY_MONGO_TYPE,
    NDR_SHIPMENT_CONCERNS_MONGO_TYPE,
    NPR_ENQUIRY_MENU,
    NPR_SHIPMENT_CONCERNS_MENU,
    NPR_ENQUIRY_MONGO_TYPE,
    NPR_SHIPMENT_CONCERNS_MONGO_TYPE,
    CUSTOMER_CARE_NUMBER,
    CUSTOMER_CARE_CLICKABLE,
    CUSTOMER_CARE_CONNECT_PROMPT,
    DELIVERED_ENQUIRY_MONGO_TYPE,
    DELIVERED_ENQUIRY_MONGO_TYPE_ALT,
    DELIVERED_SHIPMENT_CONCERNS_MENU,
    DELIVERED_SHIPMENT_CONCERNS_MONGO_TYPE,
    DELIVERED_NOT_RECEIVED,
    DELIVERED_NOT_RECEIVED_AGREEMENT,
    DELIVERED_INCORRECT_SHIPMENT_PREFIX,
    DELIVERED_INCORRECT_SHIPMENT_FLOW,
    DELIVERED_FLOW_END,
    DELIVERED_USE_MONGO_MENUS,
    DELIVERED_ENQUIRY_MENU_FALLBACK,
};

export {
    NDR_CWFD_AGREEMENT,
    NDR_CWFD_CALL_LOG,
    NDR_CWFD_REATTEMPT,
    NDR_CWFD_REATTEMPT_DELAY,
    NDR_CWFD_MAX_ATTEMPTS,
    NDR_CWFD_FLOW_END,
    NDR_CRA_AGREEMENT,
    NDR_CRA_CALL_LOG,
    NDR_CRA_REATTEMPT,
    NDR_CRA_REATTEMPT_DELAY,
    NDR_CRA_MAX_ATTEMPTS,
    NDR_CRA_FLOW_END,
    NDR_ADI_AGREEMENT,
    NDR_ADI_CALL_LOG,
    NDR_ADI_REATTEMPT,
    NDR_ADI_REATTEMPT_DELAY,
    NDR_ADI_FLOW_END,
    NPR_ADI_AGREEMENT,
    NPR_ADI_CALL_LOG,
    NPR_ADI_REATTEMPT,
    NPR_ADI_FLOW_END,
    NDR_PNC_MAX_ATTEMPTS,
    NDR_PNC_REATTEMPT,
    NDR_PNC_REATTEMPT_DELAY,
    NDR_PNC_RESCHEDULE,
    NDR_PNC_DATE_SELECTION,
    NDR_PNC_FLOW_END,
    RPCANCEL_REFUND_MAX_ATTEMPTS,
    RPCANCEL_REFUND_REATTEMPT,
    RPCANCEL_REFUND_RESCHEDULE,
    RPCANCEL_REFUND_DATE_SELECTION,
    RPCANCEL_REFUND_FLOW_END,
    RPCANCEL_PICKUP_AGREEMENT,
    RPCANCEL_PICKUP_CALL_LOG,
    RPCANCEL_PICKUP_REATTEMPT,
    RPCANCEL_PICKUP_MAX_ATTEMPTS,
    RPCANCEL_PICKUP_FLOW_END,
    NPR_RESCHEDULE_PICKUP,
    NPR_PICKUP_DATE_SELECTION,
    NPR_HANDED_AGREEMENT,
    NPR_HANDED_CALL_LOG,
    NPR_HANDED_NOT_VALIDATED,
    NPR_HANDED_FLOW_END,
    NPR_CWFP_AGREEMENT,
    NPR_CWFP_CALL_LOG,
    NPR_CWFP_REATTEMPT,
    NPR_CWFP_FLOW_END,
    NPR_PICKUP_WHERE_IS_LABEL,
    STILL_HAVE_QUERY,
    NDR_ENQUIRY_MENU,
    NDR_SHIPMENT_CONCERNS_MENU,
    NDR_ENQUIRY_MONGO_TYPE,
    NDR_SHIPMENT_CONCERNS_MONGO_TYPE,
    SHIPMENT_CONCERNS_BUTTON,
    NPR_ENQUIRY_MENU,
    NPR_SHIPMENT_CONCERNS_MENU,
    NPR_ENQUIRY_MONGO_TYPE,
    NPR_SHIPMENT_CONCERNS_MONGO_TYPE,
    UPDATE_CONTACT_ADDRESS,
    CHANGE_ADDRESS_CONFIRMATION,
    CUSTOMER_CARE_NUMBER,
    CUSTOMER_CARE_CLICKABLE,
    CUSTOMER_CARE_CONNECT_PROMPT,
    DELIVERED_ENQUIRY_MONGO_TYPE,
    DELIVERED_ENQUIRY_MONGO_TYPE_ALT,
    DELIVERED_SHIPMENT_CONCERNS_MENU,
    DELIVERED_SHIPMENT_CONCERNS_MONGO_TYPE,
    DELIVERED_NOT_RECEIVED,
    DELIVERED_NOT_RECEIVED_AGREEMENT,
    DELIVERED_INCORRECT_SHIPMENT_PREFIX,
    DELIVERED_INCORRECT_SHIPMENT_FLOW,
    DELIVERED_FLOW_END,
    DELIVERED_USE_MONGO_MENUS,
    DELIVERED_ENQUIRY_MENU_FALLBACK,
};
